exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".empty{text-align:center;font-size:16px;padding:30px}.prifile-order-total{font-size:16px;letter-spacing:0;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.prifile-order-total,.prifile-order-total .order-total-left,.prifile-order-total .order-total-right{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.prifile-order-total .order-calculate{border-left:2px solid #5e6d82;padding:0 17px;line-height:2;font-size:16px;color:#5e6d82;letter-spacing:0}.prifile-order-total .order-calculate>span{color:#0084ff}.prifile-order-total .order-subtotal{color:#5e6d82;margin-right:20px}.prifile-order-total .order-subtotal span{font-size:16px;letter-spacing:0}.prifile-order-total .order-subtotal .total-price{font-size:24px}.text-primary{color:#0084ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c232f802","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/Order/Ongoing.vue
// module id = 409
// module chunks = 0